<template>
  <span></span>
</template>
<script>
import { APP_CONFIG } from '@/config/config'
import slugg from '@/filters/sluggify.js'
export default {
  filters: {
    slugg,
  },
  props: ['name', 'description', 'id', 'type', 'imageProp'],
  data() {
    return {
      siteUrl: APP_CONFIG.siteUrl,
    }
  },
  computed: {
    url() {
      if (this.type)
        return (
          APP_CONFIG.siteUrl +
          this.type +
          '/' +
          this.id +
          '/' +
          this.$options.filters.slugg(this.name)
        )
      return this.siteUrl
    },
    image() {
      if (this.imageProp) return this.imageProp
      return this.siteLogo
    },
  },
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.name,
      // all titles will be injected into this template
      titleTemplate: '%s | ' + APP_CONFIG.siteName,
      description: this.description,
      link: [{ rel: 'canonical', href: this.url }],
      meta: [
        { property: 'og:description', content: this.name, vmid: 'og:description' },

        { property: 'og:locale', content: this.name },
        { property: 'og:type', content: 'article' },
        { property: 'og:title', content: this.name },
        { property: 'og:description', content: this.description },
        { property: 'og:url', content: this.url },

        { name: 'twitter:image', content: this.image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:description', content: this.description },
        { name: 'twitter:title', content: this.name },
        { name: 'twitter:site', content: APP_CONFIG.siteName },
        { name: 'twitter:creator', content: APP_CONFIG.siteName },
      ],
    }
  },
}
</script>
